import React from 'react';

const AboutUs = () => (
    <div>
        <h4>About Us</h4>
    </div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/AboutUs.js